import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { requestEarningsCalculation, requestEarningsCalculationSuccess, requestEarningsCalculationError } from './actionCreators';
import { reduxKey } from './constants';
const handler = handleActions({
    [requestEarningsCalculation.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isBusy: true,
            isError: false,
            errorMsg: undefined,
            result: undefined
        }),
    [requestEarningsCalculationSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isBusy: false,
            isError: false,
            errorMsg: undefined,
            result: action.payload
        }),
    [requestEarningsCalculationError.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            isBusy: false,
            isError: true,
            errorMsg: action.payload,
            result: undefined
        })
}, {
    isBusy: false,
    isError: false,
    errorMsg: undefined,
    result: undefined
});
export default {
    [reduxKey]: handler
};
